import { AdObjectActiveStatus, EffectiveAdsetStatus } from '../facebook';
import {
  exampleFacebookTargetingSpec,
  FacebookTargetingSpec,
} from '../facebook/audience';
import { FacebookAdError } from './AdError';

export interface Adset {
  id: number;
  businessID: number;
  name?: string | null;
  status?: EffectiveAdsetStatus | null;
  // Active status simply refers to whether or not the adset is active/paused
  activeStatus?: AdObjectActiveStatus | null;
  facebookID?: string | null;
  created_at?: number | null;
  updated_at?: number | null;
  targeting?: FacebookTargetingSpec | null;
  audienceID?: number | null;
  errors?: FacebookAdError[];
}

export const exampleAdset: Adset = {
  id: 1,
  businessID: 5,
  name: '10 mi',
  status: 'ACTIVE',
  facebookID: '11111',
  created_at: 1603908720,
  updated_at: 1603908720,
  targeting: exampleFacebookTargetingSpec,
};
